import { CATALOG_SECTIONS_ENUM, CatalogSectionInfo } from "./catalog-tab-layout-types";

export const CATALOG_SECTIONS_INFO: CatalogSectionInfo = {
  [CATALOG_SECTIONS_ENUM.TECHNICKS]: {
    name: "Техника",
    btnAddName: "Добавить технику",
  },
  [CATALOG_SECTIONS_ENUM.PERSONALS]: {
    name: "Персонал",
    btnAddName: "Добавить сотрудника",
  },
  [CATALOG_SECTIONS_ENUM.APPUSERS]: {
    name: "Пользователи",
    btnAddName: "Добавить пользователя",
  },
  [CATALOG_SECTIONS_ENUM.SZR]: {
    name: "СЗР",
    btnAddName: "Добавить СЗР",
  },
  [CATALOG_SECTIONS_ENUM.FERTILISER]: {
    name: "Удобрения",
    btnAddName: "Добавить удобрения",
  },
  [CATALOG_SECTIONS_ENUM.SEEDS]: {
    name: "Семена",
    btnAddName: "Добавить семена",
  },
  [CATALOG_SECTIONS_ENUM.CROPS]: {
    name: "Культуры",
    btnAddName: "Добавить культуру",
  },
  [CATALOG_SECTIONS_ENUM.PHENOPHASE]: {
    name: "Фенофазы",
    btnAddName: "Добавить фенофазу",
  },
  [CATALOG_SECTIONS_ENUM.WEEDS]: {
    name: "Сорняки",
    btnAddName: "Добавить сорняк",
  },
  [CATALOG_SECTIONS_ENUM.PESTS]: {
    name: "Вредители",
    btnAddName: "Добавить вредителя",
  },
  [CATALOG_SECTIONS_ENUM.DISEASES]: {
    name: "Болезни",
    btnAddName: "Добавить болезнь",
  },
};
